import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {authorProfileAndPostsFetch, authorFeedFetch, completeAuthorProfileUpdate, updateUserSession, authorRolesFetch, showLoginModal, fetchAuthorArticles, userBlockListFetch} from '../../../actions/index';
import {getUrlImage, gtmSend} from '../../../helpers';
import cx from '../../../styles';
import { Icon } from '../../../components/Common/Icon';
// import style from './style.css';
import { translate } from 'react-i18next';
import BaseLayout from '../../../components/Layout/BaseLayout';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import FeedContainer from '../../Feed';
import BoothFeedContainer from '../../Booth/Feed';
import AuthorDescriptionComponent from '../../../components/Author/AuthorDescription';
import AuthorInfoStripComponent from '../../../components/Author/AuthorInfoStrip';
import AuthorNetworkInfoComponent from '../../../components/Author/AuthorNetworkInfo';
import UserBlockList from '../../../components/Author/UserBlockList';
import AuthorRolesModal from '../../../components/Author/AuthorRolesModal';
import { defaultCountry, isBeYeuTemplate } from '../../../config'

const placeholder_square = getUrlImage({imgPath: 'placeholder_square.jpg', defaultImgPath: 'tap-assets/placeholder_square.jpg'})

const ArticleContainer = (props) => {
    const returnArticleStatusSvg = (status) => {
        switch(status){
            case "publish":
                return (
                    <div className={cx(`status-wrap ${status}`)}>
                        <span>
                            {props.t('published_status')}
                        </span>
                        <Icon name="right-arrow-btn" color='#219164'/>
                    </div>
                )
            break;

            case 'pending':
            case 'draft':
                return (
                    <div className={cx(`status-wrap ${status}`)}>
                        <span>
                            {props.t('in_draft_status')}
                        </span>
                        <Icon name="draft-icon" color='#DB7433'/>
                    </div>
                )
            break;

            case 'rejected':
                return (
                    <div className={cx(`status-wrap ${status}`)}>
                        <span>
                            {props.t('rejected')}
                        </span>
                        <Icon name="rejected-icon" color='#CC2924'/>
                    </div>
                )
            break;
        }
    }

    const returnWPAdminURL = (country,type) => {
        switch(country) {
            case 'sg':
            case 'th':
            case 'my':
            case 'ph':
            case 'id':
                return `https://${process.env.REACT_APP_ENV === 'production' ? `${country}` : `dev-${country}`}-admin.theasianparent.com/contributor-registration?action=${type}`;
            break;

            case 'in':
                return `https://${process.env.REACT_APP_ENV === 'production' ? `` : `dev-`}admin.theindusparent.com/contributor-registration?action=${type}`;
            break;

            default:
                return `https://${process.env.REACT_APP_ENV === 'production' ? `sg` : `dev-sg`}-admin.theasianparent.com/contributor-registration?action=${type}`;
            break;
        }
    }

    const showWriteArticleButton = (isLogin) => {
        const country = props.userReducer && props.userReducer.id ? props.userReducer.country : defaultCountry; 

        if(isLogin){
            return !isBeYeuTemplate && (
                <div className={cx('article-btn-wrap')}>
                    <a href={returnWPAdminURL(country,`add`)}>
                        <Icon name="write-new-article-icon" />
                        <span>
                            {props.t('write_new_article')}
                        </span>
                    </a>
    
                    <a href={returnWPAdminURL(country,`list`)}>
                        <span>
                            {props.t('see_all_articles')}
                        </span>
                        <Icon name="see-all-article-icon" />
                    </a>
                </div>
            )   
        }
    }
    if(props.articleData && props.articleData.post && props.articleData.post.length > 0 && props.feedReducer.author && props.feedReducer.author.is_blocked === 0) {
        return (
            <div className={cx(`author-article-container-wrap shadow-card`)}>
                {
                    showWriteArticleButton(props.userReducer.id ? true : false)
                }

                {
                    props.articleData && props.articleData.post && props.articleData.post.length > 0 &&
                    <div className={cx('article-section-wrap')}>
                        {
                            props.articleData.post.map((article,index) => {
                                return(
                                    <div className={cx('article-wrap')} key={index}>
                                        {
                                            article.status === 'publish'? 
                                            <a href={article.link} target="_blank" className={cx('content-wrap')}>
                                                <div className={cx('image-wrap')}>
                                                    <img src={article.image || placeholder_square} alt="article-image" loading="lazy" height='90px' width='90px'/>
                                                </div>
                                                <div className={cx('description-wrap')}>
                                                    <div className={cx('category-wrap')}>
                                                        <div>
                                                            {article.category[0].name}
                                                        </div>
                                                        <div>
                                                            {returnArticleStatusSvg(article.status)}
                                                        </div>
                                                    </div>
                                                    <div className={cx('title-wrap')}>
                                                        {article.title}
                                                    </div>
                                                </div>
                                            </a>
                                       :
                                       <div className={cx('content-wrap')}>
                                            <div className={cx('image-wrap')}>
                                                <img src={article.image || placeholder_square} alt="article-image" loading="lazy" height='90px' width='90px'/>
                                            </div>
                                            <div className={cx('description-wrap')}>
                                                <div className={cx('category-wrap')}>
                                                    <div>
                                                        {article.category[0].name}
                                                    </div>
                                                    <div>
                                                        {returnArticleStatusSvg(article.status)}
                                                    </div>
                                                </div>
                                                <div className={cx('title-wrap')}>
                                                    {article.title}
                                                </div>
                                            </div>
                                        </div>
                                        }
                                       
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
        )
    }else {
        return (
            <div className={cx('author-article-container-wrap-not-found')}>
                {showWriteArticleButton(props.userReducer.id ? true : false)}
                <div className={cx(`shadow-card no-result-text`)}>
                    {props.t('search_empty')}
                </div>
            </div>
        )
    }
}
class AuthorViewContainer extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            currentFeed: 'posts', 
            isRolesClicked: false, 
            articleArray : props.authorArticle && props.authorArticle.articleData && props.authorArticle.articleData.articles && props.authorArticle.articleData.articles.post && props.authorArticle.articleData.articles.post.length > 0 && props.authorArticle.articleData.articles || [],
        };
        this.types = {posts: 1, replies: 1};
    }

    componentDidMount(){
        //if server filled
        if(this.props.feedReducer.ifServerFilled) {
            if(this.props.location.hash == '#memories') return this.onInfoStripSwitch('booth');
        }

        if(this.props.authorArticle && this.props.authorArticle.articleData && this.props.authorArticle.articleData.length === 0) {
            this.fetchAuthorArticlesData(this.props.userReducer.country || defaultCountry,this.props.match.params.slug);
        }
        if(this.props.blockUserList && this.props.blockUserList.userList && this.props.blockUserList.userList.length === 0) {
            this.fetchBlockUserList();
        }

        //to prevent dynamic feed
        if(this.props.feedReducer.accessedFrom == this.props.location.pathname) return false;
        
        //on mount
        const slug = this.props.match.params.slug;
        if(!this.props.feedReducer.author || (this.props.feedReducer.author.slug != slug) || !(this.props.feedReducer.currentFeed in this.types)) {
            if(this.props.location.hash == '#memories') {
                this.props.authorProfileAndPostsFetch('posts', 1, slug, true, this.props.location.pathname)
                .then(()=>this.onInfoStripSwitch('booth'));
            } else {
                gtmSend('click user profile tab', 'user-profile', 'click', 'posts');
                this.props.authorProfileAndPostsFetch('posts', 1, slug, true, this.props.location.pathname)
                .then((response) => {
                    if(response.profile && response.profile.block_user && response.profile.block_user.anonymous_status === 1){
                        window.location.href = '/feed'
                    }else{
                        this.updateUserProfile(response);
                    }
                });
            }
        }

        //scroll fix
        window.scrollTo(0,0);
    }

    componentWillReceiveProps(nextProps) {
        if((nextProps.location.pathname != this.props.location.pathname)) {
            gtmSend('click user profile tab', 'user-profile', 'click', 'posts');
            this.setState({currentFeed: 'posts'});
            this.props.authorProfileAndPostsFetch('posts', 1, nextProps.match.params.slug, true, this.props.location.pathname)
            .then((response) => {
                this.updateUserProfile(response);
            });

            this.fetchAuthorArticlesData(nextProps.userReducer.country || defaultCountry, nextProps.match.params.slug);
        }
    }

    updateUserProfile = (response) => {
        if(response && response.profile && response.profile.id == this.props.userReducer.id){
            const user = response.profile;
            const userData = {
                date_of_delivery: user.date_of_delivery,
                gender: user.gender,
                is_pregnant: user.is_pregnant,
                kidsInfo: user.advance_kids_info ? user.advance_kids_info.all : this.props.userReducer.kidsInfo,
                num_kids: user.advance_kids_info ? user.advance_kids_info.all.length : this.props.userReducer.num_kids,
                tracker_type: user.tracker_type
            };
            this.props.completeAuthorProfileUpdate(userData);
            this.props.updateUserSession({...this.props.userReducer, ...userData});
        }
    }

    buildRightSidebar = () => {
        const ads = this.props.configReducer.ads,
            AuthorNetworkInfo = this.props.feedReducer.author ? <AuthorNetworkInfoComponent author={this.props.feedReducer.author}/> : "",
            rc = [
            <div className={cx("shadow-card")}>
                {AuthorNetworkInfo}
            </div>,
            this.props.feedReducer.author && this.props.feedReducer.author.id == this.props.userReducer.id && this.props.blockUserList && this.props.blockUserList.userList && this.props.blockUserList.userList.length > 0 &&
            <div className={cx("shadow-card")}>
                <UserBlockList userList={this.props.blockUserList.userList} mobileView={false} t={this.props.t}/>
            </div>,
            ads.networkId &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
        ];

        return rc;
    }

    fetchAuthorArticlesData = (country,userName) => {
        this.props.fetchAuthorArticles(country,userName)
            .then((data) => {
                if(data && data.articles && data.articles.post && data.articles.post.length > 0) {
                    this.setState({
                        articleArray : data.articles
                    })
                }
            })
            .catch((err) => {
                console.log("we have error here",err);
            })
    }
    fetchBlockUserList = () => {
        if(this.props.userReducer && this.props.userReducer.slug === this.props.match.params.slug){
            this.props.userBlockListFetch(1, this.props.match.params.slug)
        }
    }
    onInfoStripSwitch = (type) => {
        gtmSend('click user profile tab', 'user-profile', `click:${type}`, this.props.feedReducer.author.id);
        if(type == 'booth') {
            this.props.history.push({hash: 'memories'});
        } else {
            this.props.history.push({hash: ''});
        }
        this.setState({currentFeed: type});

        if(type !== "articles" && this.props.feedReducer.author && this.props.feedReducer.author.is_blocked === 0) {
            this.props.authorFeedFetch(type, 1, this.props.feedReducer.author.id, true, this.props.location.pathname);
        }
    }

    handleRolesClick = (value) => {
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `Author roles`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `Author roles`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } 
        else {
            gtmSend('dynamic','Author roles','click', this.props.location.pathname);
            this.setState({isRolesClicked: value});
            if(value){
                this.props.authorRolesFetch();
            }
        }
    }

    returnSelectedContainer = (feedType) => {

        let component = '';
        switch(feedType){
            case 'booth':
                component = <BoothFeedContainer {...this.props} subType="author" />
            break;

            case 'articles':
                component = <ArticleContainer {...this.props} articleData={this.state.articleArray}/>
            break;

            default:
                component = <FeedContainer {...this.props} subType="author" currentFeed={this.state.currentFeed}/>
            break;
        }
        
        return component;
    }
    render(){
        const t = this.props.t,
            author = this.props.feedReducer.author,
            rc = this.buildRightSidebar();
        // const siteUrl = this.props.configReducer.siteUrl;
        // let lc = [];
        return (
            <BaseLayout className={cx("author-view-container")} history={this.props.history} rightCards={rc} match={this.props.match} landingUrl={this.props.landingUrl}>

                <div className={cx("shadow-card", "no-pad")}>
                    { author && <AuthorDescriptionComponent userTapId={this.props.userReducer.id} author={author} ifSelf={author.id == this.props.userReducer.id} t={t} handleRolesClick={this.handleRolesClick} articleCount={this.state.articleArray.total || 0}/> }
                </div>

                {
                    author && author.id == this.props.userReducer.id && this.props.blockUserList && this.props.blockUserList.userList && this.props.blockUserList.userList.length > 0 &&
                    <div className={cx('only-mobile', 'shadow-card')}>
                        <UserBlockList userList={this.props.blockUserList.userList} mobileView={true} t={t}/>
                    </div>
                }

                { author && <AuthorInfoStripComponent author={author} switchHandler={this.onInfoStripSwitch} currentFeed={this.state.currentFeed} articleCount={this.state.articleArray.total || 0}/> }

                {
                    this.returnSelectedContainer(this.state.currentFeed)
                    // this.state.currentFeed == 'booth'
                    // ?
                    // <BoothFeedContainer {...this.props} subType="author" />
                    // :
                    // <FeedContainer {...this.props} subType="author" currentFeed={this.state.currentFeed}/>
                }

                {
                    this.state.isRolesClicked &&
                    <AuthorRolesModal 
                        isModalOpen={this.state.isRolesClicked}
                        handleRolesClick={this.handleRolesClick}
                        userRoles={this.props.appReducer.userRoles}
                    />
                }
            </BaseLayout>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        authorProfileAndPostsFetch,
        authorFeedFetch,
        completeAuthorProfileUpdate,
        updateUserSession,
        authorRolesFetch,
        showLoginModal,
        fetchAuthorArticles,
        userBlockListFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(AuthorViewContainer));